module.exports = __webpack_public_path__ + "img/error_state_light.e956d25e.png";